export default __webpack_public_path__ + "static/media/bookmark-empty.00cdae38.svg";